module.exports = __webpack_public_path__ + "img/Atelier_8.eb9678cb.jpg";